import { FreeformReviewPanel } from "@/components/aicheck/FreeformReviewPanel";
import type { ActiveTab } from "@/components/aicheck/hooks/useTraceabilityHistory";
import type {
  AggregatedProjectData,
  FreeformCheckResult,
  OutputLanguage,
  ProjectDataSourceDescriptor,
} from "@/types/aicheck";

interface FreeformTabProps {
  activeTab: ActiveTab;
  projectId?: number;
  projectData: AggregatedProjectData;
  language: OutputLanguage;
  source?: ProjectDataSourceDescriptor;
  initialTemplateId?: string;
  initialPrompt?: string;
  /** FreeformReviewPanel を再マウントするための key（キャッシュ復元時の初期値差し替え用） */
  remountKey: string;
  onProjectDataReferenceClick: (source: string) => void;
  onResultChange: (result: FreeformCheckResult | null) => void;
}

/** 「Freeform Review」タブ本体。tabpanel ラッパ + FreeformReviewPanel。 */
export function FreeformTab({
  activeTab,
  projectId,
  projectData,
  language,
  source,
  initialTemplateId,
  initialPrompt,
  remountKey,
  onProjectDataReferenceClick,
  onResultChange,
}: FreeformTabProps) {
  return (
    <div
      id="results-panel-freeform"
      role="tabpanel"
      aria-labelledby="results-tab-freeform"
      hidden={activeTab !== "freeform"}
    >
      <FreeformReviewPanel
        key={remountKey}
        projectId={projectId}
        projectData={projectData}
        language={language}
        source={source}
        initialTemplateId={initialTemplateId}
        initialPrompt={initialPrompt}
        onProjectDataReferenceClick={onProjectDataReferenceClick}
        onResultChange={onResultChange}
      />
    </div>
  );
}
